import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackoverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay, 
  cibCcAmex
} from '@coreui/icons'
import {
  cifUs,
  cifBr,
  cifIn,
  cifFr,
  cifEs,
  cifPl
} from '@coreui/icons'
import {
  cilArrowRight,
  cilBan,
  cilBasket,
  cilBell,
  cilCalculator,
  cilCalendar,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilBriefcase,
  cilDoubleQuoteSansLeft,
  cilHome,
  cilInfo,
  cilChevronCircleDownAlt,
  cilPlus,
  cilAddressBook,
  cilClipboard,
  cilShareAlt,
  cilTrash,
  cilChevronRight,
  cilChartLine,
  cilReload,
  cilLoopCircular,
  cilHistory,
  cilListRich,
  cilChart,
  cilClock,
  cilHeart,
  cilArrowCircleRight,
  cilCalendarCheck,
  cilArrowTop,
  cilCaretTop,
  cilEducation,
  cilAvTimer,
  cilX,
  cilArrowThickRight,
  cilPaperPlane,
  cilPhone,
  cilInput,
  cilNotes,
  cilArrowLeft,
  cilCart,

} from '@coreui/icons'
import { logo } from './logo'

export const iconsSet = Object.assign(
  {},
  { logo },
  {
    cilArrowRight,
    cilBan,
    cilBasket,
    cilBell,
    cilCalculator,
    cilCalendar,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilBriefcase,
    cilDoubleQuoteSansLeft,
    cilHome,
    cilInfo,
    cilChevronCircleDownAlt,
    cilPlus,
    cilAddressBook,
    cilClipboard,
    cilShareAlt,
    cilChartLine,
    cilReload,
    cilLoopCircular,
    cilHistory,
    cilTrash,
    cilChevronRight,
    cilListRich,
    cilChart,
    cilClock,
    cilHeart,
    cilArrowCircleRight,
    cilCalendarCheck,
    cilArrowTop,
    cilCaretTop,
    cilEducation,
    cilAvTimer,
    cilX,
    cilArrowThickRight,
    cilPaperPlane,
    cilPhone,
    cilInput,
    cilNotes,
    cilArrowLeft,
    cilCart,
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackoverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard, 
    cibCcVisa, 
    cibStripe, 
    cibPaypal, 
    cibGooglePay,
    cibCcAmex
  }
)
